import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Link, Avatar, Paper, Modal, Backdrop, Fade, CircularProgress } from '@mui/material';
import background from '../assets/img/Login.jpg';
import topo from '../assets/img/Fundo.png';
import logo from '../assets/img/Logo.png';
import user from '../assets/img/User.png';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { Password } from '@mui/icons-material';
import Api from '../api/Api'
import { useNavigate, useLocation } from 'react-router-dom';

const LoginScreen = () => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [errors, setErrors] = useState({ email: '', senha: '' });
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [senhaErrors, setSenhaErrors] = useState({ novaSenha: '', confirmarSenha: '' });
  const [loadingReset, setLoadingReset] = useState(false);
    const navigate = useNavigate();

  const resetLoginForm = () => {
    setEmail('');
    setSenha('');
    setErrors({ email: '', senha: '' });
  };

  const resetPasswordModal = () => {
    setNovaSenha('');
    setConfirmarSenha('');
    setSenhaErrors({ novaSenha: '', confirmarSenha: '' });
  };

  const handleSubmit = async () => {
    setLoading(true);
    let valid = true;
    const newErrors = { email: '', senha: '' };

    if (!email) {
      newErrors.email = 'O e-mail é obrigatório';
      valid = false;
    }

    if (!senha) {
      newErrors.senha = 'A senha é obrigatória';
      valid = false;
    } else if (senha.length < 6) {
      newErrors.senha = 'A senha deve ter no mínimo 6 caracteres';
      valid = false;
    }

    setErrors(newErrors);

    if (valid) {
      try {
      localStorage.removeItem("token");
      localStorage.removeItem("loginTime");


        const data = {
          email: email,
          password: senha
        }

        const result = await Api.Login(data);
        if (result.success) {


          
          toast.success("Login efetuado com sucesso");
          localStorage.setItem("loginTime", Date.now());
          localStorage.setItem("token", JSON.stringify(result.token));
          localStorage.setItem("perfil", JSON.stringify(result.perfil));
          localStorage.setItem("nome", JSON.stringify(result.nome));
          localStorage.setItem("id", JSON.stringify(result.id));
        

        setTimeout(() => {
            navigate("/home");
          }, 3500);

          resetLoginForm(); // Reseta os inputs do login após sucesso
        }
        else if (result.message === "Senha") {
          localStorage.setItem("tk_senha", JSON.stringify(result.token));
          toast.warning("Para continuar deve alterar a sua senha");
          setOpenModal(true);
        }

        else if (result.message === "Pagamento") { toast.error("O usuário não tem permissão para fazer login");}

        else if (result.message === "Login") { toast.error("O usuário tem sessão iniciada em outro dispositivo");}


        else {
          toast.error("Credenciais incorretas, por favor tente novamente");
        }

      } catch (error) {
        toast.error(error);
      }
    }
    setLoading(false);
  };

  const handleResetSenha = async () => {
    let isValid = true;
    const newErrors = { novaSenha: '', confirmarSenha: '' };

    if (!novaSenha) {
      newErrors.novaSenha = 'A nova senha é obrigatória';
      isValid = false;
    } else if (!/^(?=.*[A-Z])(?=.*[\W_]).{6,}$/.test(novaSenha)) {
      newErrors.novaSenha = '6 caracteres, 1 maiúscula e 1 símbolo.';
      isValid = false;
    } else if (novaSenha === senha) {
      newErrors.novaSenha = 'A nova senha não pode ser igual à senha anterior';
      isValid = false;
    }

    if (!confirmarSenha) {
      newErrors.confirmarSenha = 'Confirme a senha';
      isValid = false;
    } else if (novaSenha !== confirmarSenha) {
      newErrors.confirmarSenha = 'As senhas não coincidem';
      isValid = false;
    }

    setSenhaErrors(newErrors);

    if (isValid) {
      setLoadingReset(true);
      const tk = JSON.parse(localStorage.getItem('tk_senha'));

      try {
        const data = {
          password: novaSenha,
          token: tk
        };
        
        const result = await Api.AlterSenha(data);
        if (result.success) {
          toast.success("Senha alterada com sucesso");
          setOpenModal(false);
          setSenha(novaSenha);
          resetPasswordModal();
          resetLoginForm();
        } else {
          toast.error(result.message || "Erro ao alterar senha");
        }
      } catch (error) {
        toast.error("Erro ao alterar senha");
      } finally {
        setLoadingReset(false);
        localStorage.removeItem("tk_senha");
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleResetSenha();
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    resetPasswordModal(); // Reseta os inputs ao fechar o modal
  };

  return (
    <div>
      <Box
        sx={{
          minHeight: '96.5vh',
          backgroundImage: `url(${background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        <Paper
          elevation={5}
          sx={{
            width: 350,
            borderRadius: 3,
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              height: 110,
              backgroundImage: `url(${topo})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative',
            }}
          >
            <Avatar
              src={user}
              sx={{
                width: 150,
                height: 150,
                position: 'absolute',
                top: 10,
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            />
          </Box>

          <Box sx={{ p: 3, pt: 6 }}>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <img src={logo} alt="Logo" style={{ height: 100 }} />
            </Box>

            <form onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}>
              <TextField
                fullWidth
                type="email"
                label="E-mail"
                variant="outlined"
                margin="normal"
                value={email}
             
                onChange={(e) => setEmail(e.target.value)}
                error={!!errors.email}
                helperText={errors.email}
                InputProps={{
                  sx: { height: 40, fontSize: '14px' },
                }}
                InputLabelProps={{
                  sx: { fontSize: '12px' },
                }}
                 inputProps={{
    maxLength: 50,  
  }}
              />

              <TextField
                fullWidth
                label="Senha"
                type="password"
                variant="outlined"
                margin="normal"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                error={!!errors.senha}
                helperText={errors.senha}
                InputProps={{
                  sx: { height: 40, fontSize: '14px' },
                }}
                InputLabelProps={{
                  sx: { fontSize: '12px' },
                }}
                 inputProps={{
    maxLength: 50,  
  }}
              />

              <Button
                loading={loading}
                disabled={loading}
                type="submit"
                variant="contained"
                fullWidth
                sx={{ mt: 2, mb: 1 }}
              >
                {loading ? <CircularProgress size={24} /> : 'Entrar'}
              </Button>
            </form>

            <Box sx={{ textAlign: 'center' }}>
              <Link href="/criar_conta" underline="hover">Criar conta</Link><br />
              <Link href="#" underline="hover">Recuperação de senha</Link>
            </Box>
          </Box>

          <Box sx={{ textAlign: 'center', pb: 2 }}>
            <Typography variant="caption">Versão 1.0.9</Typography>
          </Box>
        </Paper>
      </Box>

      {/* Modal para alteração de senha */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <Box 
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleResetSenha();
            }}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2
            }}
          >
            <Typography id="transition-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
              Alterar Senha
            </Typography>
            <TextField
              fullWidth
              label="Nova Senha"
              type="password"
              variant="outlined"
              margin="normal"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              onKeyPress={handleKeyPress}
              error={!!senhaErrors.novaSenha}
              helperText={senhaErrors.novaSenha}
              InputProps={{
                sx: { height: 40, fontSize: '14px' },
              }}
              InputLabelProps={{
                sx: { fontSize: '12px' },
              }}
            />
            <TextField
              fullWidth
              label="Confirmar Senha"
              type="password"
              variant="outlined"
              margin="normal"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              onKeyPress={handleKeyPress}
              error={!!senhaErrors.confirmarSenha}
              helperText={senhaErrors.confirmarSenha}
              InputProps={{
                sx: { height: 40, fontSize: '14px' },
              }}
              InputLabelProps={{
                sx: { fontSize: '12px' },
              }}
            />
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={handleCloseModal} sx={{ mr: 1 }}>
                Cancelar
              </Button>
              <Button 
                variant="contained" 
                type="submit"
                disabled={loadingReset}
              >
                {loadingReset ? <CircularProgress size={24} /> : 'Alterar Senha'}
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <ToastContainer />
    </div>
  );
};

export default LoginScreen;